import { requestHandler } from '../../api';

export const getCollectionsDocumentIndicators = async (dispatch: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/indicators/documents`,
    dispatch,
  });
  if (response) return response.data;
};

export const getCollectionsManagementsIndicators = async (dispatch: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/indicators/management`,
    dispatch,
  });
  if (response) return response.data;
};

export const getCollectionsRecoveryIndicators = async (dispatch: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/indicators/recovery`,
    dispatch,
  });
  if (response) return response.data;
};

export const completeCollectionManagement = async (
  dispatch: any,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/collection/management/${id}/complete`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const completeMultipleCollectionManagement = async (
  dispatch: any,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/collection/management/complete/batch`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const deleteMultipleCollectionManagement = async (
  dispatch: any,
  data: any,
) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/collection/management/delete/batch`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const rescheduleMultipleCollectionManagement = async (
  dispatch: any,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/collection/management/reschedule/batch`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const unDoCompleteCollectionManagement = async (
  dispatch: any,
  id: number,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/collection/management/${id}/uncomplete`,
    dispatch,
  });
  if (response) return response.data;
};

export const getCollectionManagementById = async (
  dispatch: any,
  id: number,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/management/${id}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getDocumentsForCollection = async (
  dispatch: any,
  query: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/documents?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getAvailableDocumentsForCollection = async (
  dispatch: any,
  query: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/documents/available?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getDocumentDetailedForCollection = async (
  dispatch: any,
  id: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/documents/${id}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getExecutivesForDocumentCollection = async (
  dispatch: any,
  query: any,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/documents/available/collectors?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getDocumentsChartsData = async (dispatch: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/documents/charts`,
    dispatch,
  });
  if (response) return response.data;
};

export const getBusinessUsersPortfolio = async (dispatch: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/businesses/portfolio`,
    dispatch,
  });
  if (response) return response.data;
};

export const rescheduleCollectionManagement = async (
  dispatch: any,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/collection/management/${id}/reschedule`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const createMultipleCollectionManagement = async (
  dispatch: any,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/collection/management/multiple/create`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const getByStakeholder = async (dispatch: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/byStakeholder`,
    dispatch,
  });
  if (response) return response.data;
};

export const getManagementsGroupedBy = async (dispatch: any, query: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/groupedByBusiness?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getManagementsByBusiness = async (
  dispatch: any,
  businessId: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/managements/byBusiness/${businessId}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getDocumentsDataForCollection = async (
  dispatch: any,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/collection/documents/data`,
    dispatch,
    data,
  });
  if (response) return response.data;
};
